export const norwigianTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'Kommandolinjene har blitt oppdatert!',
  'Le texte a été enregistré avec succès': 'Teksten ble vellykket registrert',
  'La traduction a été enregistrée avec succès':
    'Oversettelsen ble lagret vellykket',
  'Texte + Traduction enregistré avec succès':
    'Tekst + Oversettelse ble lagret vellykke',
  'Nombre de mots': 'Antall ord',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Kundens fornavn/etternavn',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'Datoen må være senere enn i dag.',
  'Contenu rédigé': 'Skriftlig innhold',
  'Nom/prénom': 'Etternavn/fornavn',
  'Mot de passe incorrect': 'Feil passord',
  Institutions: 'Institusjoner',
  'Veuillez donner un descriptif au document téléchargé':
    'Vennligst gi en beskrivelse av det nedlastede dokumentet',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Neste',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"': 'Separer nøkkelord med "enter".',
  Allemand: 'Tysk',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'en e-post med en lenke for tilbakestilling av passord har blitt sendt til e-posten din.',
  'Chef edito': 'Sjefforfatter',
  Croate: 'Kroatisk',
  'Nb de textes': 'Antall tekster',
  Violet: 'Fiolett',
  'Ce champs doit être sup ou égale nombre de texte':
    'Dette feltet må være større enn eller lik antall tekst.',
  'a été activé avec succès': 'er vellykket aktivert',
  Népalais: 'Nepalesisk',
  'Nombre de FAQ': 'Antall vanlige spørsmål',
  Urdu: 'Urdu',
  'Analyses restantes': 'Resterende analyser',
  Indonésien: 'Indonesisk',
  Breton: 'Bretonsk',
  Livrés: 'Leveres',
  Associations: 'Sammenslutninger',
  'Le client': 'Kunden',
  'Révision demandée': 'Anmodning om gjennomgang',
  "Une erreur s'est produite, veuillez réessayer":
    'En feil har oppstått, vennligst prøv igjen',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Uautorisert oppdatering etter hvert som tekster har blitt levert',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'For å legge til tekst (optimalisere eksisterende innhold)',
  Gaélique: 'Gælisk',
  'La ligne de commande pour': 'Kommandolinjen for',
  'Business/Management': 'Virksomhet/ledelse',
  Serbe: 'Serbisk',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Vennligst angi nedenfor dine forespørsler om endringer, med tanke på våre strykebetingelser',
  'rédacteurs trouvés': 'finne forfattere',
  'Kirghiz ; Kirghiz': 'Kirgisisk; Kirgisisk',
  Différence: 'Forskjell',
  'en cours': 'under arbeid',
  'Sami du Nord': 'Nordsamisk',
  Comparer: 'Sammenlign',
  Lituanien: 'Litauisk',
  'Typix - Mon tableau de bord': 'Typix - Mitt dashbord',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Må være minst 8 tegn langt med en stor bokstav, et tall, et spesialtegn og ikke identisk med navnet.',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Vennligst fyll inn gyldige felter',
  Basque: 'Baskisk',
  'Exporter .csv': 'Eksporter .csv',
  'Confirmer le nouveau mot de passe': 'Bekreft nytt passord',
  "Pas d'options": 'Ingen alternativer',
  'Banque/Assurance': 'Bank/forsikring',
  'Vos demandes': 'Dine forespørsler',
  'Coût d\u2019achat': 'Innkjøpskostnad',
  Tamil: 'Tamilsk',
  'Le texte a été supprimé avec succès': 'Teksten ble vellykket slettet',
  'Mes Commandes': 'Mine bestillinger',
  Zoulou: 'Zulu',
  Afficher: 'Utsikt',
  Texte: 'Tekst',
  Islandais: 'Islandsk',
  Russe: 'Russisk',
  'Tous les textes': 'Alle tekster',
  Czech: 'tsjekkisk',
  'Comparaison hors ligne': 'Frakoblet sammenligning',
  Téléphonie: 'Telefoni',
  'Valider le texte': 'Valider teksten',
  'Votre text ne de doit pas dépasser 500 mots':
    'Teksten bør ikke overstige 500 ord',
  'Coquilles (double espace, « s »\u2026)': 'Skall (dobbelt mellomrom, "s"...)',
  'le consultant': 'konsulenten',
  Coréen: 'Koreansk',
  'Nb de Silo': 'Antall siloer',
  Validés: 'Validert',
  'non attribuées': 'ikke tildelt',
  Néerlandais: 'Nederlandsk',
  'Voulez-vous vraiment supprimer': 'Vil du virkelig slette',
  Rundi: 'Rundi',
  Regional: 'Regionalt',
  'Compte client': 'Kundekonto',
  Global: 'Globalt',
  'Tous les rôles': 'Alle roller',
  Musique: 'Musikk',
  Perso: 'Personlig',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Det ser ut til at du ikke har mer analysekreditt',
  Bambara: 'Bambara',
  Sortir: 'Kom deg ut',
  optionel: 'valgfritt',
  'Temps restant': 'Gjenstående tid',
  Ukrainien: 'Ukrainsk',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'Din anmodning om gjennomgang er sendt.',
  'Typix - Créer rédacteur': 'Typix - Opprett en forfatter',
  "n'existe pas": 'finnes ikke',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'kan ikke slettes ettersom det er knyttet til nettsteder',
  'Commandes en cours': 'Pågående bestillinger',
  'Textes livrés': 'Leverte tekster',
  Validation: 'Validering',
  'Non attribuées': 'Ikke tildelt',
  'Voulez-vous vraiment désactiver': 'Ønsker du virkelig å deaktivere',
  'Catalan ; Valencien': 'Katalansk; valensiansk',
  'Nombre de textes restants': 'Antall gjenværende tekster',
  'Ne doit pas contenir votre nom': 'Må ikke inneholde navnet ditt',
  Documentation: 'Dokumentasjon',
  Kazakh: 'Kasakhisk',
  'Numéro invalide': 'Ugyldig nummer',
  'Veuillez saisir un texte ou importer un fichier.':
    'Vennligst skriv inn en tekst eller importer en fil.',
  'Nb de FAQ': 'Antall vanlige spørsmål',
  Analyser: 'Analysere',
  Turc: 'Tyrkisk',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Alle forespørsler som ikke er spesifisert i mandatet',
  Wallon: 'Vallonsk',
  Birmane: 'Burmesisk',
  Irlandais: 'Irsk',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Tilbakestill passordet ditt',
  Cuisine: 'Kjøkken',
  'Haïtien ; créole haïtien': 'Haitiansk; haitisk kreolsk',
  'Vous ne pouvez pas supprimer le rédacteur': 'Du kan ikke slette forfattere',
  Validé: 'Validert',
  "cet email n'existe pas": 'denne e-posten finnes ikke',
  Historique: 'Historie',
  Confirmer: 'Bekreft',
  'à cocher si le nombre de mots est différent par texte':
    'krysses av dersom antall ord er forskjellig for hver tekst.',
  'Fiche du site web ': 'Nettstedsark',
  Désactiver: 'Deaktiver',
  'Travaux/BTP': 'Bygge- og anleggsarbeider',
  'La fiche du website': 'Nettstedsarket',
  'Si le contenu ne respecte pas les règles du brief':
    'Hvis innholdet ikke overholder reglene i oppdragsbeskrivelsen',
  Norvégien: 'Norsk',
  '0 rédacteurs': '0 forfattere',
  indisponible: 'ikke tilgjengelig',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Reviderte tekster',
  'Status texte': 'Tekststatus',
  'textes livrés en attente de validation':
    'tekster levert i påvente av validering',
  'Typix - Mon Profile': 'Typix - Min profil',
  'le client': 'klienten',
  Romanche: 'Romanche',
  'URL du site': 'Nettadressen til nettstedet',
  'nouvelles notifications': 'nye meldinger',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; maldivisk; maldivisk',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Er du sikker på at du vil lagre teksten',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Vennligst legg til en innledende tekst for å lagre teksten som et utkast.',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'Kontrakten for kunden',
  rédacteurs: 'forfattere',
  'Ce champ est obligatoire': 'Dette feltet er obligatorisk',
  'Tarif/Mot': 'Sats/ord',
  Tadjik: 'Tadsjikisk',
  'Réf devis': 'Ref sitat',
  'Rechercher un rédacteur': 'Søk etter en forfatter',
  Albanais: 'Albansk',
  Galicien: 'Galicisk',
  Disponibilité: 'Tilgjengelighet',
  'Les deux mots de passe ne sonts pas identiques':
    'De to passordene er ikke identiske',
  Tibétain: 'Tibetansk',
  'Typix - Gestion des utilisateurs': 'Typix - Brukeradministrasjon',
  'Ossétien ; Ossétique': 'Ossetisk; ossetisk',
  Tswana: 'Tswana',
  'Ajouter un client': 'Legg til en kunde',
  'Séparez les mots-clés par un " Enter ".':
    'Separer nøkkelordene med "Enter".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Temaer',
  'Nb mots/texte': 'Antall ord/tekst',
  Commerce: 'Handel',
  'Voir les commandes': 'Se ordrene',
  'Nombre de mots par texte': 'Antall ord per tekst',
  'Lien drive...': 'Link drive...',
  'Hollandais ; Flamand': 'Nederlandsk; flamsk',
  'Mon profil': 'Min profil',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Dette feltet må være større enn 0 fordi faktureringen ikke er reell.',
  'Le texte a été validé avec succès': 'Teksten har blitt validert',
  Jeux: 'Spill',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Ønsker du virkelig å fjerne kommandolinjen for',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Nord; Ndebele Nord',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Kirkeslavisk; gammelslavisk; kirkeslavisk; gammelbulgarsk; gammelslavisk; kirkeslavisk',
  Swahili: 'Swahili',
  Voyage: 'Reise',
  'Nombre de mot à ajouter': 'Antall ord som skal legges til',
  'Liste des rédacteurs': 'Liste over forfattere',
  'le rédacteur': 'forfattere',
  Kanuri: 'Kanuri',
  rédacteur: 'forfatter',
  Tatar: 'Tatarisk',
  'Roumain ; Moldave ; Moldovan': 'Rumensk; moldovisk',
  'Le texte initial de': 'Den opprinnelige teksten til',
  'Mail clients': 'Kundepost',
  'Le contrat de': 'Kontrakten med',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'minst én liten og én stor bokstav, ett spesialtegn og ett tall.',
  Transport: 'Transport',
  'Nombre total de mots (existants et ajoutés) :':
    'Totalt antall ord (eksisterende og nye) :',
  'Rechercher par mail, prénom, nom, site...':
    'Søk etter e-post, fornavn, etternavn, nettsted...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Antall ord som skal legges til (Min/Maks) :',
  Compte: 'Konto',
  'Tourisme/Loisirs': 'Turisme/fritid',
  'Nouveau texte': 'Ny tekst',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; grønlandsk',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Oops...! Det er en eller flere feil i det semantiske gap-vinduet. Vennligst sjekk innholdet for å rette den/dem og send inn teksten på nytt.',
  'ne peut pas être supprimé pour le moment':
    'kan ikke slettes på dette tidspunktet',
  'Le texte': 'Teksten',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    'Det finnes allerede en bruker med e-postadressen',
  Cree: 'Cree',
  Prénom: 'Fornavn',
  'commandes prête': 'bestillinger klare',
  Réinitialiser: 'Tilbakestill',
  'Veuillez fournir une date valide': 'Vennligst oppgi en gyldig dato',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Luxembourgsk; Letzeburgesch',
  Suédois: 'Svensk',
  'Confirmer le mot de passe': 'Bekreft passord',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Dette feltet er obligatorisk og kan bare inneholde tall',
  Sciences: 'Vitenskap',
  Tchétchène: 'Tsjetsjensk',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'er den eneste klienten for et nettsted, må andre legges til for å fjerne det.',
  'Le mot de passe de confirmation ne correspond pas':
    'Bekreftelsespassordet samsvarer ikke',
  Swati: 'Swati',
  Danois: 'Dansk',
  Sauvegarder: 'Lagre',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Vennligst endre følgende informasjon: tittel og/eller nøkkelord',
  'importer un document': 'importere et dokument',
  Maltais: 'Maltesisk',
  'Nb de mots': 'Antall ord',
  'Les données fournies sont invalides': 'De oppgitte dataene er ugyldige',
  'Livraison estimée': 'Estimert levering',
  'Grec moderne (1453-)': 'Moderne gresk (1453-)',
  Avestan: 'Avestan',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Totalt antall ord lagt til',
  'le contenu présente des inexactitudes':
    'innholdet inneholder unøyaktigheter',
  Finnois: 'Finsk',
  'Ajouter un admin': 'Legg til en administrator',
  'Min/Max': 'Min/Maks',
  'Modifier le consultant': 'Endre konsulenten',
  'Liste des clients': 'Liste over kunder',
  'Nom client': 'Kundens navn',
  Vert: 'Grønn',
  'Mots clés manquants': 'Manglende nøkkelord',
  Lao: 'Lao',
  Somali: 'Somalisk',
  'Nb de silo par texte': 'Antall siloer per tekst',
  Italien: 'Italiensk',
  'La commande a été mis à jour avec succès !':
    'Bestillingen har blitt oppdatert!',
  Bosniaque: 'Bosnisk',
  'Thématiques d\u2019expertise': 'Temaer for ekspertise',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Dette er passordet du har glemt',
  'a été désactivé avec succès': 'har blitt deaktivert',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Søk om bestillingen',
  'mot-clé': 'nøkkelord',
  Abkhazien: 'Abkhasisk',
  Mongolien: 'Mongolsk',
  'Typix - Fiche site web': 'Typix - Nettsted',
  'Mail envoyé': 'Post sendt',
  Géorgien: 'Georgisk',
  'Si des phrases ne sont pas dans un français correct':
    'Hvis setningene ikke er på korrekt fransk',
  'En cours': 'Under arbeid',
  voir: 'se',
  "Date d'ajout": 'Dato lagt til',
  'Tarif au mot': 'Pris per ord',
  Thai: 'Thai',
  'Détails du texte': 'Detaljer om teksten',
  'Commandes en retard': 'Forsinkede bestillinger',
  disponible: 'tilgjengelig',
  Droit: 'Lovgivning',
  Azerbaïdjanais: 'Aserbajdsjansk',
  'Ajouter un consultant': 'Legg til en konsulent',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Ved avspilling av innhold støttes bare følgende elementer',
  'doit comprendre au moins 8 charactères': 'må inneholde minst 8 tegn',
  'Titre de la commande': 'Tittel på bestillingen',
  'Langues bihari': 'Bihari-språk',
  'Livraison estimé au': 'Anslått levering innen',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'Antallet tekster i bestillingen kan ikke være mindre enn antallet tekster som er tildelt skribenten(e). Vennligst endre informasjonen i kommandolinjen først',
  'Date de livraison': 'Leveringsdato',
  'Voulez-vous vraiment supprimer le contrat de':
    'Ønsker du virkelig å avskaffe',
  'Facturation au réel': 'Faktisk fakturering',
  'Gap sémantique': 'Semantisk gap',
  Estonien: 'Estisk',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Maks innkjøpskostnad/ord',
  'Détail de la commande': 'Bestillingsdetaljer',
  'Export en cours de téléchargement\u2026': 'Eksporten lastes opp...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Dette feltet er obligatorisk og må være mindre enn eller lik totalt antall tekster i bestillingen.',
  Arabe: 'Arabisk',
  Bislama: 'Bislama',
  'Mail client': 'Kundepost',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Tittel, nøkkelord, url, tag, metabeskrivelse)',
  'Typix - Nouvelle commande': 'Typix - Ny ordre',
  'Révision en attente': 'Gjennomgang pågår',
  'Le consultant': 'Konsulenten',
  Entreprise: 'Selskap',
  Aragonais: 'Aragonesisk',
  Kashmiri: 'Kashmiri',
  'a été activé': 'har blitt aktivert',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (den internasjonale sammenslutningen for hjelpespråk)',
  Actualités: 'Nyheter',
  'Votre décision a été prise en compte avec succès':
    'Beslutningen din er tatt i betraktning',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'innhold som venter på kundebekreftelse',
  'Fiche du rédacteur': 'forfatteres fil',
  Outillage: 'Verktøy',
  'Typix - Détails de la commande': 'Typix - Bestillingsdetaljer',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Legg til eller fullfør innholdet nedenfor:',
  Ewe: 'Får',
  'contenu en attente de repasse rédacteur':
    'innhold i påvente av avspillingsredigering',
  'La commande a été supprimé avec succès':
    'Bestillingen ble vellykket slettet',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Franske uttrykk eller setninger som ikke passer deg',
  Corse: 'Korsika',
  Modifier: 'Rediger',
  'Nb de GMB': 'Antall GMB',
  Oromo: 'Oromo',
  Polish: 'Polsk',
  'Insérez votre gap sémantique avec l’occurrence':
    'Sett inn ditt semantiske gap med forekomsten',
  'Nb de textes à optimiser': 'Antall tekster som skal optimaliseres',
  Mode: 'Modus',
  Akan: 'Akan',
  'Révisions effectués': 'Utførte revisjoner',
  'Modifier l\u2019admin': 'Rediger administratoren',
  'Télécharger le document': 'Last ned dokumentet',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'forfatteres merknader',
  Quechua: 'Quechua',
  Féroïen: 'Færøysk',
  'Modifier le rédacteur': 'Endre forfatter',
  Mail: 'Post',
  Rédacteurs: 'Forfattere',
  'Typix - Détails du texte': 'Typix - Tekstdetaljer',
  Hongrois: 'Ungarsk',
  'Bon pour livraison': 'God for levering',
  'Au réel': 'I den virkelige verden',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Hebraisk',
  'Nombre total de mots ajoutés :': 'Totalt antall ord lagt til :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum':
    'Må være mindre enn det maksimale antallet',
  'Nom du texte': 'Navn på teksten',
  'Ajouter un rédacteur': 'Legg til en forfatter',
  Ou: 'Eller',
  Utilisateurs: 'Brukere',
  Heures: 'Timer',
  'Santé/Bien-être': 'Helse/velvære',
  'Interlingue ; Occidental': 'Flerspråklig; vestlig',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Latvisk',
  Anglais: 'engelsk',
  Envoyer: 'Send',
  'Tableau de bord': 'Dashbord',
  'Demande de révision': 'Anmodning om gjennomgang',
  'Résultat sémantique': 'Semantisk resultat',
  'Chercher un rédacteur': 'Søk etter en forfatter',
  'Ce champs est obligatoire': 'Dette feltet er obligatorisk',
  Rédaction: 'Lederartikkel',
  'Modifier le client': 'Endre klienten',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Vil du virkelig slette forfattere',
  Titre: 'Tittel',
  Langue: 'Språk',
  'Mot clé': 'Nøkkelord',
  'Les demandes suivantes ne seront pas prises en compte':
    'Følgende søknader vil ikke bli vurdert',
  'délai dépassé': 'oversittet frist',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Eksisterende kontrakt, vennligst endre informasjonen',
  Igbo: 'Igbo',
  Yiddish: 'Jiddisk',
  'Limburgan ; Limburger ; Limburgish': 'Limburgan; Limburger; Limburgsk',
  'Commandes validées': 'Validerte bestillinger',
  'listeRedacteur-': 'listforfatter-',
  Étape: 'Trinn',
  'Energie/Environnement': 'Energi/miljø',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom': 'må ikke inneholde navn/fornavn',
  'Typix - Fiche rédacteur': 'Typix - Forfatterens fil',
  'révisions effectuées en attentes de validation':
    'revisjoner i påvente av validering',
  'Textes validés': 'Validerte tekster',
  Art: 'Kunst',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Allsidig',
  Sundanese: 'Sundanese',
  'Nb total de textes': 'Totalt antall tekster',
  'Nombre de mots gérés': 'Antall ord som forvaltes',
  "L'émail": 'Emalje',
  'Afficher les résultats': 'Vis resultater',
  'Frison occidental': 'Vestfrisisk',
  'Modification effectuée avec succès': 'Endringen er fullført',
  'Balise titre': 'Tittelkode',
  'Typix - Mon profil': 'Typix - Min profil',
  'email invalide': 'ugyldig e-post',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Legg til en nettadresse slik at du kan lagre teksten som et utkast.',
  Macédonien: 'Makedonsk',
  'Votre candidature a bien été envoyée': 'Søknaden din er sendt',
  'E-mail': 'E-post',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Legg til eller fullfør innholdet nedenfor',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Legge til nøkkelord med gjenværende frekvens',
  'Fiche du site web': 'Nettstedsark',
  Contacter: 'Kontakt',
  Fidjien: 'Fijiansk',
  Déconnexion: 'Frakobling',
  email: 'e-post',
  'Nombre de textes': 'Antall tekster',
  'Enregistrer et informer client': 'Registrering og informasjon til kunder',
  'Date de validation': 'Valideringsdato',
  'Tonga (Îles Tonga)': 'Tonga (Tongaøyene)',
  Javanais: 'javanesisk',
  Portugais: 'Portugisisk',
  Biélorusse: 'Hviterussisk',
  'Pour ajouter un nouveau texte': 'For å legge til en ny tekst',
  'Enfant/Puéri': 'Barn/Puperium',
  'Mots clés': 'Nøkkelord',
  Emploi: 'Sysselsetting',
  'Voulez-vous vraiment supprimer la commande de':
    'Ønsker du virkelig å fjerne',

  Consultants: 'Konsulenter',
  Volapük: 'Volapük',
  Services: 'Tjenester',
  'mot-clé (fréquence)': 'nøkkelord (frekvens)',
  'Ne plus afficher ce message': 'Ikke vis denne meldingen igjen',
  Consultant: 'Konsulent',
  "Une erreur s'est produite": 'Det har oppstått en feil',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Minst 8 tegn med en stor bokstav, et tall eller et spesialtegn.',
  'Pushto ; Pashto': 'Pushto; pashto',
  Français: 'Fransk',
  validées: 'validert',
  'Url du site': 'Nettstedets nettadresse',
  Précédent: 'Tidligere',
  'car celui-ci a déjà rédigé des textes':
    'fordi sistnevnte allerede har utarbeidet tekster',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Utkast',
  Ido: 'Ido',
  'Contenu disponible': 'Tilgjengelig innhold',
  Enseignement: 'Undervisning',
  'a été livré avec succès': 'har blitt levert med suksess',
  Chinois: 'Kinesisk',
  Vietnamien: 'Vietnamesisk',
  'Nouveau client': 'Ny kunde',
  'Votre profil a été mis à jour avec succès.':
    'Profilen din har blitt oppdatert.',
  Consignes: 'Instruksjoner',
  'Mot de passe': 'Passord',
  Annuler: 'Avbryt',
  Non: 'Nei',
  Nom: 'Navn',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'det er pålegg knyttet til nettstedet',
  Score: 'Resultat',
  'Mot de passe mis à jour avec succès': 'Passordet er oppdatert',
  Latin: 'Latin',
  Technologie: 'Teknologi',
  Internet: 'Internett',
  Nauru: 'Nauru',
  'a été créé avec succès': 'har blitt opprettet',
  Roumain: 'Rumensk',
  Assamais: 'assamesisk',
  'Khmer central': 'Sentral-Khmer',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Analyse/grense',
  Grec: 'Gresk',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Mine prosjekter',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'nøkkelord1 (2)\nnøkkelord2 (1)\nnøkkelord3 (1)\nnøkkelord4 (2)\n...',
  'ajouter un texte': 'legg til en tekst',
  'Détail de la prestation': 'Detaljer om tjenesten',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'Du har mulighet til å eksportere rapporten for en eller flere bestillinger. For å eksportere alle ordrene til en kunde, trenger du bare å klikke på det gule nedlastingsikonet.',
  'Gestion des utilisateurs': 'Brukeradministrasjon',
  'livré et inférieur au nombre de texte non affecté':
    'levert og mindre enn antall ikke-tildelte tekster',
  'Date deadline validation client': 'Frist for kundevalidering',
  Aymara: 'Aymara',
  Validées: 'Validert',
  Notes: 'Merknader',
  'Nombre de GMB': 'Antall GMB-er',
  'résultats sur': 'resultater på',
  'Prénom / Nom du client': 'Fornavn / Navn på klienten',
  'Tout télécharger': 'Last ned alle',
  'Champs obligatoires': 'Påkrevde felter',
  Éditer: 'Rediger',
  'Coller le texte initial dans le champs ci-dessous':
    'Lim inn originalteksten i feltet nedenfor',
  'ID rédacteur': 'forfatter-ID',
  Arménien: 'Armensk',
  'Grande distribution': 'Distribusjon i stor skala',
  Welsh: 'Walisisk',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Semantisk berikelse',
  'Détail de la prestation du contenu': 'Detaljer om levering av innhold',
  Noir: 'Svart',
  'Ajouter un texte': 'Legg til en tekst',
  Traduction: 'Oversettelse',
  'Immo/Defisc': 'Eiendom/skatt',
  'Brief détaillé': 'Detaljert sammendrag',
  'Séparez les mots-clés par un Enter .': 'Separer nøkkelordene med Enter .',
  Prix: 'Utmerkelser',
  'mot de passe oublié': 'Glemt passord',
  'Ndebele, South ; South Ndebele': 'Ndebele, Sør; Sørlige Ndebele',
  'Demander une révision': 'Be om en gjennomgang',
  'Demander une repasse globale': 'Be om en omfattende gjennomgang',
  'Sotho, Southern': 'Sotho, sørlige',
  'Le titre de la commande existe déjà':
    'Tittelen på bestillingen finnes allerede',
  'Félicitations !': 'Gratulerer!',
  Kurde: 'Kurdisk',
  Adresse: 'Adresse',
  Espagnol: 'Spansk',
  Ndonga: 'Ndonga',
  'En retard': 'For sent',
  'a été ajouté avec succès': 'har blitt lagt til',
  Commandes: 'Bestillinger',
  'a été mis en brouillon': 'er utarbeidet',
  'Rédacteur attribué': 'Tildelt forfatter',
  Rechercher: 'Søk',
  'Nouvelle commande': 'Ny ordre',
  'Commandes non attribuées': 'Ikke tildelte ordrer',
  'Le texte a été mis en brouillon': 'Teksten er utarbeidet',
  'Contact edito': 'Kontakt edito',
  Langues: 'Språk',
  Orange: 'Oransje',
  'Nynorsk norvégien': 'Norsk nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turkmensk',
  'contenu repassé, en attente validation client':
    'stryket innhold, i påvente av kundevalidering',
  'Nombre de mots rédigés': 'Antall skrevne ord',
  Malay: 'Malaysisk',
  'Nombre de Silo': 'Antall Silo',
  Oui: 'Ja',
  Automobile: 'Biler',
  Résultats: 'Resultater',
  Afar: 'Langt unna',
  'Tâche - id tâche': 'Oppgave - oppgave-ID',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Dette feltet er obligatorisk og må være større enn 0.',
  'Vous êtes sûr': 'Er du sikker på at',
  'Réinitialiser votre mot de passe': 'Tilbakestill passordet ditt',
  Sindhi: 'Sindhi',
  Bengali: 'Bengali',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, norsk; norsk bokmål',
  'Nombre de Jours': 'Antall dager',
  'Min/Max mots': 'Min/Maks ord',
  Slovène: 'Slovensk',
  Site: 'Nettsted',
  'Sinhala ; Cingalais': 'Singalesisk; singalesisk',
  Bulgare: 'Bulgarsk',
  'Liste des commandes': 'Liste over bestillinger',
  "L'utilisateur": 'Brukeren',
  Uzbek: 'Usbekisk',
  'Titre du texte': 'Tittel på teksten',
  Postuler: 'Søk på',
  'Nb de textes par Silo': 'Antall tekster per Silo',
  'Nombre total de mots (existants et ajoutés)':
    'Totalt antall ord (eksisterende og tilføyde)',
  'Max.': 'Maks.',
  Beauté: 'Skjønnhet',
  Humanitaire: 'Humanitær',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Zoeken op auteur of tekst',
  'Balise meta-description': 'Metabeskrivelseskode',
  Malgache: 'Madagaskisk',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Dette feltet må være større enn 0 og mindre enn 1.',
  'Le rédacteur': 'forfattere',
  'a été mis à jour avec succès': 'har blitt oppdatert',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Må være minst 8 tegn langt med en stor bokstav, et tall, et symbol og ikke identisk med navnet.',
  'textes en plus': 'flere tekster',
  'Format souhaité': 'Ønsket format',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Detaljer om ordrelinjen',
  'Veuillez préciser la date': 'Vennligst spesifiser dato',
  Pali: 'Pali',
  Clients: 'Kunder',
  'Total facturé': 'Totalt fakturert',
  'contenu validé par le client': 'innhold validert av kunden',
  'Occitan (post 1500)': 'Okzitansk (etter 1500)',
  Japonais: 'Japansk',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': 'Ønsker du virkelig å aktivere',
  Sanskrit: 'Sanskrit',
  'Toutes les notifications': 'Alle meldinger',
  Marathi: 'Marathi',
  Persan: 'Persisk',
  'La commande pour le client': 'Bestillingen for kunden',
  'Intitulé de la commande': 'Tittel på bestillingen',
  Samoan: 'Samoansk',
  Autres: 'Annet',
  Sport: 'Sport',
  "il y'a des commandes liés au site web ":
    'det er pålegg knyttet til nettstedet',
  'Ajout de mots-clé avec la fréquence restante':
    'Legge til nøkkelord med gjenværende frekvens',
  'a été supprimé avec succès': 'har blitt fjernet',
  Postulé: 'Publisert',
  Literie: 'Sengetøy',
  'Édité par le client': 'Redigeres av kunden',
  Cornouailles: 'Cornwall',
  Tigrinya: 'Tigrinya',
  Textes: 'Tekster',
  'Soumettre un nouveau texte': 'Send inn en ny tekst',
  Téléphone: 'Telefon',
  Deadline: 'Tidsfrist',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'Det har oppstått en feil. Vennligst sjekk oppføringen eller prøv igjen senere.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'Forespørselen om å legge til kreditt sendes',
  'Le rédacteur ': 'forfattere',
  'Demander des crédits': 'Søke om kreditt',
  "Cette commande n'existe pas": 'Denne kommandoen finnes ikke',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitisk',
  Admins: 'Administratorer',
  'Mettez des mots-clés avec fréquence': 'Angi nøkkelord med frekvens',
  Notifications: 'Meldinger',
  'en retard': 'sent',
  "l'admin": 'administrasjonen',
  'Mail rédacteurs': 'E-postforfattere',
  Amharique: 'Amharisk',
  Societe: 'Virksomhet',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Antall tekster lagt til',
  Société: 'Virksomhet',
  Yoruba: 'Yoruba',
  'Le texte a été livré avec succès': 'Teksten ble levert med suksess',
  'Mettez votre texte': 'Legg inn teksten din',
  "Oups....! Une erreur s'est produite": 'Oops....! Det har oppstått en feil',
  'Prénom/Nom': 'Fornavn/efternavn',
  'Max doit être sup à Min': 'Maks må være større enn Min',
  'Importer un autre document': 'Importer et annet dokument',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Søknaden din er utløpt ... vennligst lag en ny søknad',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Korriger formatet på det semantiske gapet for å lagre teksten som et utkast.',
  Exemple: 'Eksempel',
  Slovaque: 'Slovakisk',
  Finance: 'Finans',
  Réactiver: 'Reaktivere',
  'Nb textes': 'Antall tekster',
  'Intitulé commande': 'Bestillingstittel',
  Supprimer: 'Slett',
  Brouillon: 'Utkast',
  'Mots clés restants': 'Resterende nøkkelord',
  Date: 'Dato',
  Rôle: 'Rolle',
  'Ce champs doit être sup à 0': 'Dette feltet må være større enn 0',
  'Maison/Déco': 'Hjem/Innredning',
  'Vous avez': 'Du har',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Denne kommandolinjen kan ikke slettes fordi noe av teksten er levert.',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'sjekk e-posten din og klikk på lenken for å fortsette!',
  Sarde: 'Sardinia',
  'Note rédacteur': 'forfatteres merknad',
  'Uighur ; Uyghur': 'Uigurisk; uigurisk',
  Name: 'Navn',
  'Commandes intelligentes': 'Smart kommandoer',
  'Commandes avec révision': 'Smart + revision kommandoer',
  'Type de contenu': 'Indholdstype',
  'Fiche produit': 'Produktside',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Premium-redigering',
  'Rédaction avec révision': 'Smart + revision redigering',
  'Rédaction intelligente': 'Smart redigering',
  PREMIUM: 'PREMIUM',
  Type: 'Type',
  Editer: 'Rediger',
  'Tous les types': 'Alle typer',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Behandlede fakturaer',
  'Factures à valider': 'Fakturaer som skal valideres',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Kan ikke generere fakturaen! Vennligst prøv igjen',
  'Récapitulatif de facturation': 'Oppsummering av fakturering',
  'Demander une modification': 'Be om en endring',
  'Valider et envoyer la facture': 'Validere og sende fakturaen',
  'Demande de modification': 'Endringsforespørsel',
  'La facture a été validé avec succès!':
    'Fakturaen er blitt validert med suksess!',
  "Oups un erreur c'est produit!": 'Oops, det oppstod en feil!',
  'Nombre de texte': 'Antall tekster',
  'Nombre de mot par texte :': 'Antall ord per tekst:',
  Paiement: 'Betaling',
  Virement: 'Overføring',
  Délai: 'Frist',
  'Référence de votre facture': 'Din fakturareferanse',
  'Coût au mot': 'Kostnad per ord',
  'Montant global de la commande': 'Totalt beløp for bestillingen',
  'Votre facture': 'Din faktura',
  'Importer votre facture': 'Importer din faktura',
  'Pas de fichier disponible': 'Ingen tilgjengelige filer',
  Télécharger: 'Last ned',
  Relancer: 'Sende på nytt',
  'Générer la facture': 'Generere fakturaen',
  Payée: 'Betalt',
  'En cours de paiement': 'Under betaling',
  'En cours de validation': 'Under validering',
  'A envoyer': 'Skal sendes',
  'Modification demandée': 'Endring forespurt',
  'Référence de facture est obligatoire': 'Fakturareferanse er obligatorisk',
  'Le coût au mot doit être un nombre': 'Kostnaden per ord må være et tall',
  'Le coût au mot doit être un nombre positif':
    'Kostnaden per ord må være et positivt tall',
  'Le coût au mot est obligatoire': 'Kostnaden per ord er obligatorisk',
  'Le montant global de la commande doit être un nombre':
    'Totalbeløpet for bestillingen må være et tall',
  'Le montant global de la commande doit être un nombre positif':
    'Totalbeløpet for bestillingen må være et positivt tall',
  'Le montant global de la commande est obligatoire':
    'Totalbeløpet for bestillingen er obligatorisk',
  'Bill reference existe déja , veuillez réessayer':
    'Fakturareferansen eksisterer allerede, vennligst prøv igjen',
  'La facture a été envoyée avec succès!':
    'Fakturaen er blitt sendt med suksess!',

  'Montant estimé': 'Estimert beløp',
  Action: 'Handling',
  Facture: 'Faktura',
  Statut: 'Status',
  Factures: 'Fakturaer',
  'Valider la facture': 'Godkjenn fakturaen',
  'La relance a été envoyée avec succès !': 'Purringen er sendt med suksess!',
  'La demande de modification a été envoyée avec succès !':
    'Endringsforespørselen er sendt med suksess!',
  'Le cout est trop élevé': 'Kostnaden er for høy',
  'Le montant global de la commande est trop élevé ':
    'Den totale summen av bestillingen er for høy',
  jours: 'dager',
  'Factures à envoyer': 'Fakturaer å sende',
  'Valider le paiement': 'Bekreft betaling',
  'Générer une facture': 'Generer en faktura',
  'Montant rédacteur': 'Forfatterbeløp',
  'Montant estimé par Typix': 'Estimert beløp av Typix',
  'Voir la modification': 'Vis endringen',

  'Tag de Titre': 'Tittel-tag',
  'Meta description': 'Meta-beskrivelse',
  'Nom du produit': 'Produktnavn',
  Avantages: 'Fordeler',
  'Description détaillée': 'Detaljert beskrivelse',
  'En cours de modification': 'Under endring',
  'Mes Factures': 'Mine fakturaer',
  'En attente de validation': 'Venter på validering',
  'les valeurs négatives ne sont pas autorisées':
    'Negative verdier er ikke tillatt.',
  'Texte Seulement': 'Bare tekst',
  'Traduction Seulement': 'Bare oversettelse',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'Purring kan sendes 20 dager etter fakturainnsending',
  Instructions: 'Instruksjoner',
  'Votre avis pour la commande': 'Din tilbakemelding for bestillingen',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Din evaluering er verdifull for oss! Takk!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Det oppsto en feil under innsendingen av din evaluering. Vennligst prøv igjen senere!',
  Evaluer: 'Vurdere',
  Commentaire: 'Kommentar',
  'Votre commantaire': 'Din kommentar',
  Note: 'Vurdering',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Din tilbakemelding er verdifull for oss og hjelper oss med å forbedre våre tjenester.',
  'Verifier la facture': 'Verifiser fakturaen',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Din tilbakemelding er verdifull for oss og hjelper oss med å forbedre våre tjenester. Takk for at du deler din evaluering med oss!',
  'Notes rédacteur': 'Forfatternotater',
  'Avis client': 'Kundeanmeldelser',
  'Pas de commantaire': 'Ingen kommentar',
  "Qu'avez vous pensé de votre commande?": 'Hva synes du om bestillingen din?',
  'Evaluation de la commande': 'Vurdering av bestillingen',
  'Rédiger un commentaire': 'Skriv en kommentar',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Bidra til at vi kan tilby deg tjenester av høyeste kvalitet ved å dele dine tilbakemeldinger.',
  'Que pouvons-nous améliorer?': 'Hva kan vi forbedre?',
  Continuer: 'Fortsett',
  'Le dernier texte a été validé avec succès':
    'Den siste teksten ble validering med suksess',
  'Rechercher par rédacteur, commandes, et montant':
    'Cerca per autore, ordini e importo',
  obligatoire: 'obligatorisk',
  'Note admin': 'Merknad fra administrator',
  'Note client': 'Merknad fra kunde',
  Partie: 'Del',
  'Vous venez de valider tous les contenus rédigés par ':
    'Du har nettopp godkjent all innhold skrevet av ',
  "Qu'en avez vous pensé": 'Hva synes du om det',
  'La facture a été générée avec succès !':
    'Fakturaen er generert med suksess!',
  'La taille du titre et/ou la méta-description est trop courte':
    'Lengden på tittelen og/eller meta-beskrivelsen er for kort',

  'Demande de révision globale': 'Krever en global gjennomgang',
  Valider: 'Godkjenne',
  'Obligatoire en cas d’optimisation ou traduction':
    'Påkrevet ved optimalisering eller oversettelse',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Din kommentar...',
  'Ex : "Contenus de très bonne qualité':
    'Eks.: "Meget god kvalitet på innholdet"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Kan du vennligst bruke denne skribenten til fremtidige bestillinger?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Denne knappen er for å informere klienten om at den opprinnelige teksten allerede inneholdt nøkkelordfyll',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Rediger teksten',
  Ajouter: 'Legg til',
  'Demande examen': 'Be om eksamen',
  'Recherche de mots clés à haute densité': 'Keyword stuffing forskning',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Oops, det ser ut til at det er keyword stuffing i teksten din: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Oops, det ser ut til at det er keyword stuffing (for mange forekomster av ett eller flere nøkkelord) i den opprinnelige teksten.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Vennligst sørg for at nøkkelordtettheten er optimalisert for SEO (maksimalt én forekomst for hver 50 ord).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'For dette, vennligst ikke rediger den eksisterende teksten og send en undersøkelsesforespørsel til støtte.',
  'Votre demande a été bien envoyée !': 'Ditt forespørsel har blitt sendt!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Det oppsto et problem under sendingen av forespørselen din.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Vennligst vent på analysen av nøkkelordfylling.',
  'Inserez le maillage interne': 'Sett inn intern kobling',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Vennligst sørg for at nøkkelordtettheten er optimalisert for SEO (maksimalt én forekomst hver 50. ord).\nHvis du kommer over en term som kan ha flere betydninger (Eksempel: Former / Formation / Form eller Matelas / Matelassé), kan du be om en gjennomgang fra support.',
  'Mots clés à haute densité dans le texte actuel':
    'Nøkkelord med høy tetthet i gjeldende tekst',
  'Mots clés à haute densité dans le texte initial':
    'Nøkkelord med høy tetthet i opprinnelig tekst',
  'Texte en cours de rédaction !': 'Tekst under utarbeidelse !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Er du sikker på at du vil bekrefte teksten? Forsikre deg først om at du har lagret endringene.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Siste øyeblikks informasjon! Kredittbeholdningen din vil snart være tom :( For å være føre var, nøl ikke med å be om mer kreditt nå for å fullføre bestillingen din.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Ønsker du å bekrefte den nåværende URL-en eller endre den?',
  'Veuillez fournir une URL valide': 'Vennligst oppgi en gyldig URL.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Vennligst oppgi URL-en til siden der innholdet er integrert nedenfor:',
  'Contenu en ligne': 'Nettinnhold',
  'Télécharger le document de révision': 'Last ned revisjonsdokumentet',
  'Date d’envoi': 'Sendingsdato',
  Information: 'Informasjon',
  Enregistrer: 'Lagre',
  'Textes en ligne': 'Tekster på nett',
  'Livrer les textes': 'Lever tekstene',
  Indisponible: 'Utilgjengelig',
  Disponible: 'Tilgjengelig',
  'Les textes ont été livrés avec succès.': 'Tekstene ble levert med suksess.',
  'Le texte a été livré avec succès.': 'Teksten ble levert med suksess.',
  'Les textes ont été validés avec succès.':
    'Tekstene ble validert med suksess.',
  'Le texte a été validé avec succès.': 'Teksten ble validert med suksess.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Vil du virkelig godkjenne bestillingstekstene?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Vil du virkelig levere bestillingstekstene?',
  'Fiche produit longue': 'Lang produktside',
  'Fiche produit courte': 'Kort produktside',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'En tekst er for lang og kan ikke eksporteres til Excel.',
  'Mettre un texte en brouillon en livré':
    'Endre en tekst fra utkast til levert',
  'Remettre un texte validé à livré': 'Endre en validert tekst til levert',
  'Invalider le texte': 'Ugyldiggjør teksten',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Jeg ønsker å endre passordet mitt: hvordan gjør jeg det?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Hvordan gjøre innhold klart for levering?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'Jeg kan ikke lagre innholdet mitt som "utkast"',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix lagret ikke mine siste endringer',
  'Comment rédiger une création de contenu ?':
    'Hvordan skrive innholdsopprettelse?',
  'Comment rédiger une optimisation de contenu ?':
    'Hvordan skrive innholdsoptimalisering?',
  'Je ne vois plus ma commande – que faire ?':
    'Jeg ser ikke lenger bestillingen min – hva skal jeg gjøre?',
  'Comment générer une facture ?': 'Hvordan genererer man en faktura?',
  'Je ne peux pas generer ma facture : que faire ?':
    'Jeg kan ikke generere fakturaen min: hva skal jeg gjøre?',
  'Tuto process Typix global': 'Global Typix-prosess - veiledning',
  'Tuto mise en ligne des contenus': 'Hvordan laste opp innhold - veiledning',
  'Modification mot de passe': 'Endring av passord',
  'Le test ne me convient pas': 'Testen passer meg ikke',
  'Comment valider un contenu dans Typix ?':
    'Hvordan validere innhold i Typix?',
  'Tuto Facturation': 'Fakturering-veiledning',
  'Le statut du contenu a bien été modifié': 'Innholdets status er endret',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Den semantiske gapet for dette nøkkelordet er ennå ikke validert, vennligst kontakt Typix-støtte: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Dette nøkkelordet finnes ikke på MONETORING, vennligst sjekk med Typix-støtte: support-typix@pixalione.com',
  'Récupérer le Gap': 'Hente gapet',
  'Le statut du contenu a bien été modifié': 'Innholdets status er endret',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Den semantiske gapet for dette nøkkelordet er ennå ikke validert, vennligst kontakt Typix-støtte: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Dette nøkkelordet finnes ikke på MONETORING, vennligst sjekk med Typix-støtte: support-typix@pixalione.com',
  'Récupérer le Gap': 'Hente gapet',
  'Traduction premium': 'Premium oversettelse',
  'Rédaction et/ou Traduction intelligente':
    'Intelligent skriving og/eller oversettelse',
  'Rédaction et/ou Traduction premium':
    'Premium skriving og/eller oversettelse',
  'Rédaction et/ou Traduction avec révision':
    'Skriving og/eller oversettelse med revisjon',
  'Rédaction et/ou Traduction intelligente':
    'Intelligent skriving og/eller oversettelse',
  'Traduction avec révision': 'Oversettelse med revisjon',
  'Traduction intelligente': 'Intelligent oversettelse',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'Antall bestilte ord er større enn de solgte',
  'Rédaction et/ou Traduction premium':
    'Premium skriving og/eller oversettelse',
  'Rédaction et/ou Traduction smart + review':
    'Smart skriving og/eller oversettelse + gjennomgang',
  'Rédaction et/ou Traduction smart': 'Smart skriving og/eller oversettelse',
  'Nom Silo': 'Navn Silo',
  'Remettre en brouillon': 'Tilbake til kladd',
  'Bon pour Livraison Vérifié': 'Verifisert for levering',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Er du sikker på at du vil sette ordrektene tilbake til kladd',
  'La vérification du texte a été annulée.':
    'Tekstverifiseringen er blitt kansellert.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Vil du virkelig avbryte tekstverifiseringen?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Er du sikker på at du vil generere alt innhold på nytt?',
  'Je suis sûr(e)': 'Jeg er sikker',
  'Non, revenir en arrière': 'Nei, gå tilbake',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'merk av hvis bestillingen har til hensikt å ha en eksklusiv forfatter for kunden',
  Gouvernance: 'Styring',
  'Modification à valider': 'Endring som må godkjennes',
  Rédacteur: 'Redaktør',
  'Nouveau site web': 'Ny nettside',
  'Mail Chef Project': 'Prosjektleder e-post',
  'Site web': 'Nettside',
  'Liste des siteweb': 'Nettside liste',
  'Projets non attribuées': 'Ikke-tildelte prosjekter',
  'Projets en cours': 'Pågående prosjekter',
  'Projets en retard': 'Forsinkede prosjekter',
  'Projets validées': 'Validerte prosjekter',
  'Projets smart + reviews': 'Smart + review prosjekter',
  'Projets smart': 'Smart prosjekter',
  'Ajouter un siteweb': 'Legg til et nettsted',
  'Nouveau projet': 'Nytt prosjekt',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  //////
  Balises: 'Tagger',
  Lisibilité: 'Lesbarhet',
  'Longueur des paragraphes': 'Akapitlengde',
  Phrases: 'Setninger',
  'de +100 mots sur': 'mer enn +100 ord i',
  Phrase: 'Setning',
  'de +20 mots sur': 'mer enn +20 ord i',
  'Notre recommandation': 'Vår anbefaling',
  'Longueur du texte': 'Tekstlengde',
  'Formats de contenus variés': 'Varierte innholdsformater',
  'par rapport au top 3 de vos concurrents':
    'sammenlignet med topp 3 konkurrenter',
  'Vous êtes': 'Du er',
  'Vous avez un score global de': 'Du har en samlet poengsum på',
  'pour une moyenne du secteur à': 'for et bransjegjennomsnitt på',
  'GAP comblé - Mission accomplie': 'Gap fylt – Oppdrag fullført',
  'Mots clé restants': 'Gjenværende nøkkelord',
  'Phrases de +20 mots': 'Setninger med mer enn 20 ord',
  'Titre H1': 'H1-tittel',
  'Titres H2': 'H2-titler',
  'Dans le texte actuel': 'I den nåværende teksten',
  'Dans le texte initial': 'I den opprinnelige teksten',
  mots: 'ord',
  objectif: 'mål',
  phrase: 'setning',
  paragraphe: 'avsnitt',
  'Temps de lecture': 'Lesetid',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'påkrevd (punktliste, verdt å vite, sammendrag)',
  'de contenu sur': 'innholdsmengde i',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Gratulerer! Antall ord samsvarer med mengden viktig informasjon for å svare på emnet.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Gratulerer! Innholdet ditt inneholder ingen setninger med mer enn 20 ord!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Gratulerer! Innholdet ditt er luftig og lett å lese.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Gratulerer! Innholdet ditt bruker varierte formater som gjør lesingen mer dynamisk og fremhever viktig informasjon.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Gratulerer! Innholdet har en unik H1-tag og inneholder hovednøkkelordet.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Gratulerer! Innholdet er strukturert på en sammenhengende måte og har minst to <h2>-tagger.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Gratulerer! Innholdet ditt har balanserte interne lenker som ikke forstyrrer lesingen.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Gratulerer! Berikelsesscoren er over 85 %!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Gratulerer! Teksten din er ikke overoptimalisert for det valgte nøkkelordet.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'Antall ord må samsvare med mengden viktig informasjon for å svare på emnet.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'Det er viktig å tilpasse ordforrådet til målgruppen. For enkelt språk kan virke barnslig, for komplekst språk kan gjøre innholdet utilgjengelig.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Over 70 % av brukerne leser ikke setninger med mer enn 20 ord → bruk korte setninger for å øke tiden på siden.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'For tette avsnittblokker forringer brukeropplevelsen og øker fluktfrekvensen.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Bruk ulike visningsformater for mer lesbar og behagelig lesing.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Optimalisert innhold må inneholde kun én H1-tag og nevne nøkkelordet.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'For optimal struktur kreves minst to H2-tagger.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Intern lenking er en utmerket måte å koble en side til andre relevante eller komplementære sider.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Optimalisert innhold bør oppnå minst 85 % berikelsesscore. Fjerning av semantisk innhold reduserer scoren.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Å gjenta nøkkelordet for mange ganger straffes av søkemotorer. Ideelt sett ikke mer enn 2,35 % (ca. 2 ganger per 100 ord).',
  'Aucune balise H1 trouvée.': 'Ingen H1-tag funnet.',
  'Balise H1 contient le mot-clé.': 'H1-taggen inneholder nøkkelordet.',
  'Balise H1 présente mais sans le mot-clé.':
    'H1-taggen er til stede, men inneholder ikke nøkkelordet.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} H2-tagger funnet, {{count_with_kw}} med nøkkelord.',
  ' balises H2 trouvées,': ' H2-tagger funnet,',
  ' avec mot-clé.': ' med nøkkelord.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Veldig lett å lese: tilgjengelig for barn eller personer med grunnleggende leseferdigheter.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Lett å lese: forståelig for de fleste voksne og tenåringer.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Vanskelig å lese: krever godt lesenivå, noen ganger akademisk bakgrunn.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Veldig vanskelig å lese: for eksperter eller erfarne lesere.',
  'Wording adapté': 'Tilpasset ordvalg',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'H1-taggen er essensiell for SEO-optimalisering.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Kun én H1-tag med nøkkelord anbefales.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Legg til nøkkelordet i H1-taggen.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Tilpass ordforrådet til publikum. For enkelt virker barnslig, for komplekst ekskluderer.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'Nettinnhold leses raskt. For lang lesetid kan virke demotiverende.',
  'Information sur la structure': 'Informasjon om struktur',
  'Information sur le résultat sémantique': 'Informasjon om semantisk resultat',
  'Information sur les balises HTML': 'Informasjon om HTML-tagger',
  'Information sur le keyword stuffing': 'Informasjon om overbruk av nøkkelord',
  //////
  'Derniers contenus rédigés': 'Siste skrevne innhold',
  'voir plus': 'Se mer',
  'texte': 'Tekst',
  'date d\'ajout': 'Leggedato',
  'titre du projet': 'Prosjekttittel',
  'Date de création': 'Opprettelsesdato',
  'dernières projets créés': 'Siste opprettede prosjekter',
  '% projets par statut de validation :': '% prosjekter etter godkjenningsstatus:',
  'non attribués': 'Ikke tildelt',
  'en cours': 'Pågående',
  'en retard': 'Forsinket',
  'validées': 'Godkjent',
  'smart + reviews': 'Smart + Vurderinger',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Vurdering',
  'Statut d\'avancement des contenus:': 'Status for innholdsframdrift:',
  'Nombre de textes publiés :': 'Antall publiserte tekster:',
  'Nb de textes publiés': 'Ant. publiserte tekster',
  'Top ranked': 'Best rangert',
  'Mot clé': 'Nøkkelord',
  'Clicks': 'Klikk',
  'Clicks (Y-1)': 'Klikk (Y-1)',
  'Position': 'Posisjon',
  'Sessions': 'Økter',
  'Sessions (Y-1)': 'Økter (Y-1)',
  'Evolution performance': 'Ytelsesutvikling',
  'Pourcentage': 'Prosent',
  'Livré': 'Levert',
  'Publié': 'Publisert',
  'Suivez vos contenus et projets en temps réel': 'Følg innhold og prosjekter i sanntid',
  'Tableau de bord': 'Dashbord',
  'Titre du projet': 'Prosjekttittel',
  'Conversions': 'Konverteringer',
  'Impressions': 'Visninger',
  'Jan': 'Jan',
  'Fév': 'Feb',
  'Mars': 'Mar',
  'Avr': 'Apr',
  'Mai': 'Mai',
  'Juin': 'Jun',
  'Juil.': 'Jul',
  'Août': 'Aug',
  'Sept': 'Sep',
  'Oct': 'Okt',
  'Nov': 'Nov',
  'Déc': 'Des',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'For å aktivere denne funksjonen, legg til vår adresse ',
  'à votre ': 'på din ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'deretter klikk her for å starte analysen.',
  'all devices': 'alle enheter',
  'Desktop': 'Skrivebord',
  'Mobile': 'Mobil',
  '30 days': '30 dager',
  '7 days': '7 dager',
  '90 days': '90 dager',
  'Aucun projet créé pour le moment.': 'Ingen prosjekter opprettet ennå.',
  'Lancer votre premier projet': 'Start ditt første prosjekt',
  'Aucun contenu disponible pour ce site web.': 'Ingen innhold tilgjengelig for dette nettstedet.',
  'Mes contenus': 'Mine innhold',
  'Type de contenu': 'Innholdstype',
  'Date d\'ajout': 'Leggedato',
  'URL': 'URL',
  'Status': 'Status',
  'Date de livraison': 'Leveringsdato',
  'Date de validation': 'Godkjenningsdato',
  'Date de déploiement': 'Implementeringsdato',
  'Action': 'Handling',
  'Aucun contenu pour ce filtre.': 'Ingen innhold for dette filteret.',
  'Chargement...': 'Laster...',
  'Aucun contenu.': 'Ingen innhold.',
  'Précédent': 'Forrige',
  'Suivant': 'Neste',
  'fiche produit': 'Produktark',
  'Page catégorie': 'Kategorieside',
  'Fiche GMB': 'GMB-side',
  'store locator': 'Butikklokator',
  'redaction': 'Redaksjon',
  'traduction': 'Oversettelse',
  'Fiches produit SEO': 'SEO-produktark',
  'Derniers projets crées': 'Siste opprettede prosjekter',
  'Agent IA': 'AI-agent',
  'Dérniére mise à jour': 'Sist oppdatert',
  'Créer un nouveau contenu': 'Opprett nytt innhold',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Skriv en AI-optimalisert tekst – rask, relevant og effektiv.',
  'Validé': 'Godkjent',
  'En ligne': 'Online',
  'Fiches GMB': 'GMB-sider',
  'Fiches store locator': 'Butikklokator-sider',
  'Pages catégories': 'Kategoriesider',
  'Traduction IA': 'AI-oversettelse',
  'Actions': 'Handlinger',
  'Traduire un nouveau contenu': 'Oversett nytt innhold',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Oversett innholdet ditt automatisk med flerspråklig nøyaktighet.',
  'Nom du projet': 'Prosjektnavn',
  'Chef de projet': 'Prosjektleder',
  'Deadline du projet': 'Prosjektfrist',
  'Informations globales': 'Generell informasjon',
  'Contenu du projet': 'Prosjektinnhold',
  'Séléctionner le type de contenu': 'Velg innholdstype',
  'Sélectionner un agent IA personnalisé': 'Velg tilpasset AI-agent',
  'Créer un agent IA personnalisé': 'Opprett tilpasset AI-agent',
  'Liens utiles': 'Nyttige lenker',
  'Rédacteur(s)': 'Redaktør(er)',
  'Deadline': 'Frist',
  'Nb textes': 'Antall tekster',
  'IA + Revue par rédacteur': 'AI + Redaktørgjennomgang',
  'Ajouter un projet': 'Legg til prosjekt',
  'Projets': 'Prosjekter',
  'Non attribués': 'Ikke tildelt',
  'Rédaction IA': 'AI-redaksjon',
  'Résultats sur': 'Resultater for',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Er du sikker på at du vil slette denne AI-agenten?',
  'Mes agents IA': 'Mine AI-agenter',
  'Tous': 'Alle',
  'Rédaction': 'Redaksjon',
  'Traduction': 'Oversettelse',
  'Rechercher': 'Søk',
  'Sélectionner un site': 'Velg nettsted',
  'Créer un agent IA personnalisé': 'Opprett tilpasset AI-agent',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Definer oppdrag, rolle, språk, innholdstype og mer.',
  'Nouvel agent': 'Ny agent',
  'Rôle :': 'Rolle:',
  'Type de contenu :': 'Innholdstype:',
  'Langue :': 'Språk:',
  'Siteweb :': 'Nettsted:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Velg LLM',
  'Fiche produit smart': 'Smart produktark',
  'Détails du texte': 'Tekstdetaljer',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Nøkkelord*, URL, Tittel, Meta-beskrivelse)',
  'URL siteweb*': 'Nettside-URL*',
  'Balise titre': 'Tittel',
  'Balise méta-description': 'Meta-beskrivelse',
  'Sélectionner un site web': 'Velg nettsted',
  'Sélectionner un agent IA': 'Velg AI-agent',
  'Lancer': 'Start',
  'Relancer': 'Start på nytt',
  'Génération en cours...': 'Generering pågår...',
  'Générer': 'Generer',
  'Enregistrement...': 'Lagrer...',
  'Enregistrer ': 'Lagre',
  'Livrer': 'Lever',
  'Livraison...': 'Leverer...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Siste tilføyde innhold",


  ////
  'Nom de l\'agent': 'Agentens navn',
  'Site web': 'Nettsted',
  'Mission': 'Oppdrag',
  'Langue de traduction': 'Oversettelsespråk',
  'Langue': 'Språk',
  'Tonalité': 'Tone',
  'Cible / Audience': 'Målgruppe',
  'Base de connaissance locale': 'Lokal kunnskapsbase',
  'Base de connaissance en ligne': 'Online kunnskapsbase',
  'Sélect. fichiers': 'Velg filer',
  'Ex: URL1, URL2': 'F.eks.: URL1, URL2',
  'Annuler': 'Avbryt',
  'Mettre à jour': 'Oppdater',
  'Valider': 'Bekreft',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages':
    'F.eks.: et avsnitt om intervensjonstyper, et avsnitt om fordeler',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels':
    'F.eks.: sammenleggbare paraplyer åpnes automatisk, andre er manuelle',
  '📚 Base de connaissances': '📚 Kunnskapsbase',

  'Type de produits / services proposés par le site*': 'Type produkter/tjenester som tilbys av nettstedet*',
  'Règles rédactionnelles': 'Redaksjonelle regler',
  'Lexique recommandé': 'Anbefalt ordliste',
  'Expressions interdites': 'Forbudte uttrykk',
  'Instructions de personnalisation': 'Tilpasningsinstruksjoner',

  "🧩 Informations générales": "🧩 Generell informasjon",
  "🗣️ Ton & Audience": "🗣️ Tone og målgruppe",
  "📝 Structure & Rédaction": "📝 Struktur og skriving",
  "📚 Base de connaissances": "📚 Kunnskapsbase",
  "Structure de texte attendu": "Forventet tekststruktur",
  "Enrichissement SEO": "SEO-optimalisering",
  "traduction IA": "AI-oversettelse",
  "Traduction en cours...": "Oversettelse pågår...",
  "Traduire": "Oversett",
  "Créer votre assistant éditorial sur mesure": "Opprett din skreddersydde redaksjonelle assistent",
  "Votre texte traduit": "Din oversatte tekst",
  "Détail du projet": "Prosjektdetaljer",
  "Détail d'attribution": "Tilordningsdetaljer",
  "Détail des contenus": "Innholdsdetaljer",

  "Nom agent": "Agentnavn",
  "Rédaction": "Skriving",
  "Traduction": "Oversettelse",
  "Mots clé": "Nøkkelord",
  "Url de la page": "Side-URL",
  "Entrez le mot clé principal": "Skriv inn hovedstikkord",
  "Entrez l url": "Skriv inn URL",
  "Date d'ajout": "Tilføyelsesdato",
  "Dernière mise à jour": "Siste oppdatering",
  "URL": "URL",
  "Status": "Status",
  "Actions": "Handlinger",
  "Détails du texte": "Tekstdetaljer",
  "Contenus disponibles": "Tilgjengelig innhold",
  "Textes générés": "Genererte tekster",

  "Veuillez d'abord sélectionner un site web": "Vennligst velg først et nettsted",
  "Chargement des agents...": "Laster agenter...",
  "Aucun agent disponible pour ce site": "Ingen agenter tilgjengelig for dette nettstedet",
  "Sélectionner...": "Velg...",
  "Modifier cet agent": "Rediger denne agenten",
  "Créer un agent IA personnalisé": "Opprett en tilpasset AI-agent",
  "Rédaction en cours...": "Skriving pågår...",
  "Génération en cours": "Generering pågår",
  "Rédiger un contenu": "Skriv et innhold",
  "Rédiger un lot de contenus": "Skriv en gruppe innhold",
  "Url page": "Side-URL",
  "Entrez l'URL cible de votre contenu (facultatif).": "Skriv inn mål-URL for innholdet ditt (valgfritt).",
  "GAP sémantique": "Semantisk gap",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....":
    "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Intern lenking",
  "Introduisez le maillage": "Legg inn lenkingen",
  "Introduisez le maillage interne": "Legg inn intern lenking",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊":
    "Importer en fil som inneholder listen over emner som skal skrives, og AI vil gjøre resten 😊",
  "Importer": "Importer",
  "Saisissez le mot-clé principal de votre contenu.": "Skriv inn hovednøkkelordet for innholdet ditt.",
  "Texte à traduire": "Tekst å oversette",
  "Saisissez le texte à traduire": "Skriv inn teksten som skal oversettes",
  "Traduire un contenu": "Oversett et innhold",
  "Traduire un lot de contenus": "Oversett en gruppe innhold",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊":
    "Importer en fil som inneholder listen over tekster som skal oversettes, og AI vil gjøre resten 😊",
  "Commencer la traduction": "Start oversettelsen",
  "Lancer la traduction": "Start oversettelsen",
  "Commencer la rédaction": "Start skrivingen",
  "Lancer la rédaction": "Start skrivingen",

  'En ligne...': 'På nett...',
  'Ajouter un nouveau site web': 'Legg til et nytt nettsted',
  'Créer': 'Opprett',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Velg eller legg til temaer som gjenspeiler din ekspertise.',
  'Ajoutez ou sélectionnez une thématique': 'Legg til eller velg et tema.',
  'Le site web a été créé avec succès': 'Nettstedet ble opprettet',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'Vi konfigurerer nå dine KI-agenter. De vil snart være klare til å hjelpe deg med innholdsproduksjonen.',
  'Derniers contenus ajoutés': 'Siste innhold lagt til',
  'Tous les sites': 'Alle nettsteder',
  'Sélectionner le site web': 'Velg nettsted',
  'Aucun fichier sélectionné': 'Ingen fil valgt',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'f.eks.: bruk høflig tone, bruk et ordforråd målgruppen forstår.',
  '🧠 Créer un agent IA': '🧠 Opprett en KI-agent',
  '🧠 Modifier un agent IA': '🧠 Rediger en KI-agent',
  'Ex : AMF (Autorité des Markets Financiers).': 'F.eks.: AMF (Finanstilsynet).',
  'Ex: bio, écologique, nom des concurrents': 'F.eks.: økologisk, miljøvennlig, konkurrentnavn.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Beskriv den forventede strukturen så detaljert som mulig for å veilede KI-en om hvilke temaer som skal behandles og i hvilken rekkefølge.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Legg til elementer KI-en skal eller ikke skal gjøre eller nevne.',
  'Ex: prêt-à-porter féminin': 'F.eks.: dameklær',
  'Ex: Rédacteur SEO': 'F.eks.: SEO-skribent',
  'Indiquer la liste des urls sur lesquels l\'IA peut s’appuyer': 'Oppgi listen over URL-er KI-en kan bruke som referanse.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Skap, optimaliser, prester: innholdet ditt tar en ny dimensjon.',
  'La création de contenu n\'a jamais été aussi smart.': 'Innholdsproduksjon har aldri vært så smart.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Øk produktiviteten din med kraften av flere KI-modeller. Sammenlign og kombiner de beste forslagene, og optimaliser dem med en sanntidsvurdering (SEO, lesbarhet, relevans).',
  'Je crée mon premier contenu SEO friendly': 'Jeg lager mitt første SEO-vennlige innhold.',
  'Veuillez coller le texte source....': 'Lim inn originalteksten du vil oversette…',
  'Enrichir': 'Berik',
  'Veuillez d\'abord sélectionner un site web': 'Velg først et nettsted',

  "🎯 Commencez ici": "🎯 Start her",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Legg til eller velg nettstedet du vil følge.",
  "📝 Derniers contenus créés": "📝 Nyeste opprettede innhold",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Her finner du det nyeste innholdet for det valgte nettstedet.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Klikk på en tekst for å se detaljene.",
  "📁 Derniers projets créés": "📁 Nyeste prosjekter",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Få rask tilgang til de siste prosjektene for dette nettstedet.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Klikk på et prosjekt for å se fremdriften og tilhørende innhold.",
  "📊 Suivi de vos projets": "📊 Prosjektoversikt",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Se status på prosjektene dine: pågående, forsinket eller fullført.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "En tydelig oversikt for å følge totalproduksjonen din.",
  "📑 Statut d’avancement des contenus": "📑 Status for innholdsproduksjon",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Følg fordelingen av innholdet ditt: utkast, levert og publisert.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideelt for raskt å se hvor du bør prioritere.",
  "📅 Textes publiés par mois": "📅 Publiserte tekster per måned",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Se antallet publiserte tekster per måned for det valgte nettstedet.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Følg publiseringsrytmen din over tid.",
  "⭐ Top mots-clés": "⭐ Topp nøkkelord",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Se dine 5 beste nøkkelord fra Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Sammenlign posisjon, klikk nå og klikk fra forrige år.",
  "📈 Activer le suivi du trafic": "📈 Aktiver trafikksporing",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Legg til e-posten vår i Search Console for å aktivere analysen.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Deretter kan du følge trafikkutviklingen direkte i Typix.",
  "🏠 Tableau de bord": "🏠 Dashboard",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Gå tilbake til oversikten: nøkkelindikatorer, nytt innhold, prosjekter og ytelse.",
  "🤖 Agents IA": "🤖 KI-agenter",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Konfigurer og styr KI-agentene dine for å automatisere skriving og oversettelse.",
  "✍️ Rédaction IA": "✍️ KI-skriving",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Få tilgang til KI-generatorer: produktsider, GMB-sider, kategorisider og annet optimalisert innhold.",
  "🌍 Traduction IA": "🌍 KI-oversettelse",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Oversett innholdet ditt til flere språk med noen få klikk, uten å miste SEO-konsistensen.",
  "➕ Créer un projet": "➕ Opprett et prosjekt",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Start et nytt innholdsprosjekt på få sekunder og følg fremdriften.",
  "📂 Gestion des projets": "📂 Prosjektstyring",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Se prosjektene dine: ikke tildelt, pågående, forsinket eller fullført.",
  "👤 Mon profil": "👤 Min profil",
  "Modifiez vos informations personnelles.": "Rediger dine personlige opplysninger.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Brukeradministrasjon",
  "Invitez de nouveaux membres, gérez leurs droits et organisez les équipes.": "Inviter nye medlemmer, administrer tillatelser og organiser team.",
  "❓ Mon guide": "❓ Min guide",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Start denne interaktive guiden når som helst for å finne igjen hovedfunksjonene i Typix.",
  'Mon guide': 'Min guide',
  'Se déconnecter': 'Logg ut',
  "L'adresse email est obligatoire.": "E-postadresse er obligatorisk.",
  "Le nom est obligatoire.": "Etternavn er obligatorisk.",
  "Le prénom est obligatoire.": "Fornavn er obligatorisk.",
  "Le mot de passe est obligatoire.": "Passord er obligatorisk.",
  "La confirmation est obligatoire.": "Bekreftelse er obligatorisk.",
  "Les mots de passe ne correspondent pas.": "Passordene samsvarer ikke.",
  "Récapitulatif": "Sammendrag",
  "Quitter la création": "Avslutt opprettelse",
  "Objectif du projet": "Prosjektmål",
  "Mode de production": "Produksjonsmodus",
  "Répartition du travail": "Arbeidsfordeling",
  "Contexte éditorial": "Redaksjonell kontekst",
  "Rédaction": "Skriving",
  "Traduction": "Oversettelse",
  "Créer du contenu original": "Opprett originalt innhold",
  "Traduire un contenu existant": "Oversett eksisterende innhold",
  "Identification du projet": "Prosjektidentifikasjon",
  "Nom du projet": "Prosjektnavn",
  "Vous pourrez modifier le nom plus tard": "Du kan endre navnet senere",
  "URL du site": "Nettsteds-URL",
  "Langue": "Språk",
  "Sélectionner une langue": "Velg et språk",
  "Nombre de textes": "Antall tekster",
  "12 textes disponibles": "12 tilgjengelige tekster",
  "Chef de projet": "Prosjektleder",
  "Aucun chef de projet assigné au siteweb": "Ingen prosjektleder tildelt nettstedet",
  "Sélectionner un chef de projet": "Velg en prosjektleder",
  "Date limite du projet": "Prosjektfrist",
  "Sélectionner une date limite": "Velg en frist",
  "Suivant": "Neste",
  "Retour": "Tilbake",
  "Définissez l'objectif et le cadre général de votre projet.": "Definer målet og det generelle rammeverket for prosjektet ditt.",
  "IA": "KI",
  "Production généré par IA": "KI-generert produksjon",
  "Rédacteur": "Forfatter",
  "Production Rédacteur par IA": "Forfatterproduksjon via KI",
  "IA + revue humaine": "KI + menneskelig gjennomgang",
  "IA avec validation humaine.": "KI med menneskelig validering.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Fordel tekstene i prosjektet ditt mellom deg og eventuelle forfattere.",
  "L'attribution à un rédacteur est optionnelle.": "Tildeling til en forfatter er valgfritt.",
  "Agent IA": "KI-agent",
  "Vous pourrez changer d'agent plus tard": "Du kan endre agent senere",
  "Veuillez d'abord sélectionner un site web": "Velg først et nettsted",
  "Sélectionnez le mode IA": "Velg KI-modus",
  "Aucun agent disponible": "Ingen agent tilgjengelig",
  "Sélectionner un agent IA": "Velg en KI-agent",
  "Format du contenu": "Innholdsformat",
  "Sélectionner un format": "Velg et format",
  "Nombre de mots par texte": "Antall ord per tekst",
  "Format personnalisé": "Tilpasset format",
  "définir le nombre de mots": "definer antall ord",
  "mots": "ord",
  "Options avancées": "Avanserte alternativer",
  "Enrichissement du contenu": "Innholdsberikelse",
  "Génération Image": "Bildegenerering",
  "Nombre d’images": "Antall Bilder",
  "Définir le nombre d’images": "Angi antall bilder",
  "Consomment des crédits supplémentaires": "Forbruker ekstra kreditter",
  "IA augmentée par vos données": "KI forbedret med dine data",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Velg personene som er ansvarlige for gjennomgang av KI-generert innhold og fordel",
  "les textes à valider.": "tekstene som skal valideres.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "Gjennomgangeren kan gjøre rettelser og målrettede justeringer innenfor den definerte ordgrensen,",
  "sans réécrire entièrement le contenu.": "uten å omskrive hele innholdet.",
  "Contexte éditorial & brief détaillé du projet": "Redaksjonell kontekst og detaljert prosjektbrief",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Legg til kontekstuell informasjon for å veilede og berike innholdsproduksjonen.",
  "Gap sémantique": "Semantisk gap",
  "optionnel": "valgfritt",
  "Brief détaillé": "Detaljert brief",
  "Lien drive...": "Drive-lenke...",
  "Lancer le projet": "Start prosjektet",
  "Nom du projet existant": "Prosjektnavn eksisterer allerede",
  "Un projet avec ce nom existe déjà dans votre espace.": "Et prosjekt med dette navnet eksisterer allerede i ditt område.",
  "Merci de choisir un nom différent pour continuer.": "Velg et annet navn for å fortsette.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Feil ved opprettelse av prosjekt. Prøv igjen.",
  "Félicitations !": "Gratulerer!",
  "Votre projet a été créé avec succès !": "Prosjektet ditt ble opprettet!",
  "Voir le projet": "Se prosjektet",
  "Fermer": "Lukk",
  "Paramètres du compte": "Kontoinnstillinger",
  "Site web": "Nettsted",
  "Langue du site": "Nettstedsspråk",
  "textes": "tekster",
  "Deadline": "Frist",
  "Type": "Type",
  "Rédacteur": "Forfatter",
  "Moi (par défaut)": "Meg (standard)",
  "Livraison le": "Levering den",
  "À venir": "Kommende",
  "Production généré par IA": "KI-generert produksjon",
  "Agent": "Agent",
  "Format": "Format",
  "Enrichissement du contenu activé": "Innholdsberikelse aktivert",
  "Relecteur": "Gjennomganger",
  "texte": "tekst",
  "Limite de modification": "Endringsgrense",
  "Aucune attribution": "Ingen tildeling",
  "Aucun élément ajouté": "Ingen element lagt til",
  "janvier": "januar",
  "février": "februar",
  "mars": "mars",
  "avril": "april",
  "mai": "mai",
  "juin": "juni",
  "juillet": "juli",
  "août": "august",
  "septembre": "september",
  "octobre": "oktober",
  "novembre": "november",
  "décembre": "desember",
  "à": "til",
  "mots minimum": "minimum ord",
  "mots maximum": "maksimum ord",
  "Status de validation des projets": "Prosjektvalideringsstatus",
  "Statut d'avancement des contenus": "Innholdsstatus:",
  "Total des contenus": "Totalt innhold:",
  "Non attribué": "Ikke tildelt",
  "Évolution des performances": "Ytelsesutvikling",
  "Position": "Posisjon",
  "Nombre de textes publiés": "Antall publiserte tekster",
  "Espace de travail AI": "AI-arbeidsområde",
  "Mise à jour 1.2": "Oppdatering 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Oppdag de nyeste funksjonene, optimaliseringene og feilrettingene.",
  "Projet créé": "Prosjekt opprettet",
  "Votre projet a bien été créé.": "Prosjektet ditt har blitt opprettet.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Du kan begynne å jobbe med det med en gang.",
  "Sélectionnez le mode IA": "Velg KI-modus",
  "Aucun agent disponible": "Ingen agent tilgjengelig",
  "Sélectionner un agent IA": "Velg en KI-agent",
  "Sélectionner un format": "Velg et format",
  "Veuillez d'abord sélectionner un site web": "Velg først et nettsted",

  'Nouveau contenu': 'Nytt innhold',
  'Génération en cours...': 'Generering pågår...',
  'Optimisation en cours...': 'Optimalisering pågår...',
  'Traduction en cours...': 'Oversettelse pågår...',
  'En lignes': 'På nett',
  'filtres': 'Filtre',
  'trier par': 'Sorter etter',
  'Score décroissant': 'Synkende poengsum',
  'Score croissant': 'Stigende poengsum',
  'Date de création': 'Opprettelsesdato',
  'Date de mise à jour': 'Oppdateringsdato',
  'Date récente': 'Nyeste dato',
  'Date ancienne': 'Eldste dato',
  'Mots clés': 'Nøkkelord',
  'Éditeur': 'Redaktør',
  'Créateur': 'Oppretter',
  'Rédacteurs': 'Forfattere',
  'Réinitialisé par défaut': 'Tilbakestill til standard',
  'Mode de rédaction': 'Skrivemodus',
  'Agent AI utilisé': 'Brukt AI-agent',
  'Textes en brouillons': 'Utkast',
  'Modèle': 'Mal',
  'Paramètres du projet': 'Prosjektinnstillinger',
  'Avancement': 'Status',
  'Progression': 'Fremdrift',
  'Aucun texte disponible': 'Ingen tekst tilgjengelig',
  'Détails du projet': 'Prosjektdetaljer',
  'Page {{current}} sur {{total}}': 'Side {{current}} av {{total}}',
  'Moteur LLM': 'LLM-motor',
  'Rédiger un contenu': 'Skrive innhold',
  'Traduire un contenu': 'Oversette innhold',
  'Optimiser un contenu': 'Optimalisere innhold',
  'Générer un contenu': 'Generere innhold',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Opprett en tekst for et spesifikt nøkkelord med et veiledet skjema',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Oversett en spesifikk tekst med et veiledet skjema',

  'Générez plusieurs textes en important un fichier Excel':
    'Generer flere tekster ved å importere en Excel-fil',

  'Rédiger un lot de contenus': 'Skrive en gruppe med innhold',
  'Traduire un lot de contenus': 'Oversette en gruppe med innhold',
  'Enrichir un contenu': 'Berike innhold',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Optimaliser en spesifikk tekst med et veiledet skjema',

  'Nombre total de textes alloués au projet':
    'Totalt antall tekster tildelt prosjektet',

  'Vous pourrez changer le format du contenu plus tard':
    'Du kan endre innholdsformatet senere',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Skriv inn hvert nøkkelord etterfulgt av frekvensen i parentes, og trykk Enter. Eksempel: sko(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Eks: bil(5), elektrisk(3), rekkevidde(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URL-er til sider som skal lenkes (atskilt med komma)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Trenger du hjelp til å klargjøre filen din?',

  'Télécharger le modèle (Excel)':
    'Last ned mal (Excel)',

  'Déposez votre fichier ici':
    'Last opp filen din her',

  'Glissez-déposez votre fichier Excel':
    'Dra og slipp Excel-filen din',

  'ou cliquez pour parcourir':
    'eller klikk for å bla gjennom',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Godkjente formater: .xlsx, .xls (maks 10 MB)',

  'Parcourir les fichiers':
    'Bla gjennom filer',

  'Ex: télépéage automatique':
    'Eks: automatisk bompengeinnkreving',

  'Générer le contenu': 'Generer innhold',
  'Lancer la génération': 'Start generering',
  'Commencer la traduction': 'Start oversettelse',
  'Lancer la traduction': 'Start oversettelse',

  'Partager': 'Del',
  'Telecharger le texte': 'Last ned teksten',
  'Modifier le projet': 'Rediger prosjektet',
  'Modifiez les détails de votre projet ici.':
    'Rediger prosjektdetaljene dine her.',

  'Général': 'Generelt',
  'Allocation des textes': 'Tildeling av tekster',
  'Sélectionner un format du contenu': 'Velg innholdsformat',
  'Allocation aux rédacteurs': 'Tildeling til forfattere',

  '{{count}} textes disponibles':
    '{{count}} tilgjengelige tekster',

  'Sélectionner un rédacteur': 'Velg forfatter',
  'Nom du rédacteur': 'Forfatternavn',
  'Date limite': 'Frist',
  'texte restant': 'gjenværende tekster',
  'textes alloués': 'tildelte tekster',

  'Article court - 300 mots': 'Kort artikkel – 300 ord',
  'Article moyen - 600 mots': 'Middels artikkel – 600 ord',
  'Article long - 1000 words': 'Lang artikkel – 1000 ord',
  'Youtube - 350 mots': 'YouTube – 350 ord',
  'Linkedin - 200 mots': 'LinkedIn – 200 ord',
  'X - 150 mots': 'X – 150 ord',
  'Personnalisé': 'Tilpasset',

  'Voir plus': 'Se mer',
  ' à votre ': ' i din ',
  '{{count}} textes à livrer':
    '{{count}} tekster som skal leveres',

'Nous contacter': 'Kontakt oss',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Har du et spørsmål eller et problem? Kontakt oss, så svarer vi deg så snart som mulig.',
'Sujet': 'Emne',
'Message': 'Melding',
'Soumettre ma demande': 'Send forespørselen min',
'Veuillez sélectionner un sujet': 'Vennligst velg et emne',
'Décrivez votre demande en détail...': 'Beskriv forespørselen din i detalj...',
'Sélectionnez un sujet': 'Velg et emne',
'Autre': 'Annet',
'Feedback': 'Tilbakemelding',
'Question': 'Spørsmål',
'Bug': 'Feil',
'Le message doit contenir au moins 10 caractères': 'Meldingen må inneholde minst 10 tegn',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Meldingen din ble sendt. Vi svarer deg så snart som mulig.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Forespørselen din er sendt til vårt supportteam, som vil svare deg så snart som mulig.',
'Envoi en cours...': 'Sender...',
'Fermer': 'Lukk',
'Créer un nouvel agent AI': 'Opprett en ny AI-agent',
'Mission de l\'agent': 'Agentens oppdrag',
'L\'agent générera du contenu original à partir de vos consignes.': 'Agenten vil generere originalt innhold basert på dine instruksjoner.',
'Informations générales': 'Generell informasjon',
'Informations principales': 'Hovedinformasjon',
'Ton & audience': 'Tone og målgruppe',
'Structure & rédaction': 'Struktur og redigering',
'Base de connaissances': 'Kunnskapsbase',
'Construction du contenu': 'Innholdsbygging',
'Structure attendu': 'Forventet struktur',
'Cadre lexical': 'Leksikalsk ramme',
'Personnalisation avancée': 'Avansert tilpasning',
'Base de connaissance locale en ligne': 'Lokal kunnskapsbase på nett',
'Glissez-déposez votre fichier': 'Dra og slipp filen din',
'Base de connaissance': 'Kunnskapsbase',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Oppgi listen over URL-er som AI-en kan basere seg på',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Definer den redaksjonelle posisjoneringen til agenten din slik at den tilpasser tonen sin,',
'sa cible et son vocabulaire à votre activité.': 'målgruppen og ordforrådet sitt til din virksomhet.',
'caractères': 'tegn',
};
